import { EMPTY_OBJECT } from '../../../../../../constants/common'
import { useCalendarGridItemHandlers } from '../../../../CalendarGrid.hooks'
import { getIsCalendarGridSecondaryLabelClickable } from '../../../../CalendarGrid.utils'
import { CalendarGridWeekBlock } from '../../../CalendarGridWeekBlock'

function CalendarGridWeekGroupBlock({
  blockProps,
  item = EMPTY_OBJECT,
  onClickItem,
  onClickSecondaryLabel,
}) {
  const { handleClickItem, handleClickSecondaryLabel } =
    useCalendarGridItemHandlers({
      isSecondaryLabelClickable: getIsCalendarGridSecondaryLabelClickable({
        item,
        onClickSecondaryLabel,
      }),
      item,
      onClickItem,
      onClickSecondaryLabel,
    })

  const { id, secondaryLabel, title, tooltip } = item

  return (
    <CalendarGridWeekBlock
      {...blockProps}
      hint={tooltip}
      qaContext={id}
      secondaryLabel={secondaryLabel}
      title={title}
      onClick={handleClickItem}
      onClickSecondaryLabel={handleClickSecondaryLabel}
    />
  )
}

export default CalendarGridWeekGroupBlock
